import * as THREE from "three";
import { isLine } from "./isLine";

function isPolygon(object: THREE.Object3D): object is THREE.Line & { userData: { fill: THREE.Mesh<THREE.BufferGeometry, THREE.Material> } } {
	return isLine(object) && object.userData?.fill instanceof THREE.Mesh;
}

export { isPolygon };
